"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("webmotors-react-pj/utils");
var _config = require("webmotors-react-pj/config");
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/menu/style"));
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _config2 = _interopRequireDefault(require("webmotors-react-pj/i18n/config"));
var _default = () => {
  const {
    permissions,
    unique_name: uniqueName,
    sid
  } = (0, _utils.jwtGet)();
  const editDealer = permissions.includes('23') && uniqueName !== '0';
  return _react.default.createElement("ul", null, _react.default.createElement(_style.default, {
    icon: "marketshare.svg",
    href: "".concat(_config.UrlCockpit, "/user/info/").concat(sid)
  }, _lang.default.header.myProfile), editDealer && _react.default.createElement(_style.default, {
    icon: "name-tag.svg",
    href: "".concat(_config.UrlCockpit, "/dealer")
  }, _lang.default.header.registrationData), _react.default.createElement(_style.default, {
    "data-qa": "buttonExitCockpit",
    icon: "exit.svg",
    href: "".concat(_config2.default.header.settings.logoutLink)
  }, _lang.default.header.exit));
};
exports.default = _default;